module.exports = __webpack_public_path__ + "img/Bitmap@2z1x.0d976a0d.png";